module.exports = __webpack_public_path__ + "img/standard_tb.c8d043e2.png";